import { gql } from "@apollo/client";

export const DeleteYouTubeVideo = gql`
mutation DeleteYouTubeVideo($deleteYouTubeVideoId: ID!) {
  deleteYouTubeVideo(id: $deleteYouTubeVideoId) {
    status
  }
}
`;
